import React, { useState, useEffect } from 'react';
import { Dialog } from "primereact/dialog";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { FloatLabel } from "primereact/floatlabel";
import { Link, Navigate, resolvePath } from "react-router-dom";
import { config } from "../shared/config";
import * as util from '../shared/commons';
import axios from "axios";
import { Button } from 'primereact/button';
import 'primeicons/primeicons.css';
import { Image } from "primereact/image";
import ShowError from "../shared/ShowError";
import ShowConfirm from "../shared/ShowConfirm";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Skeleton } from 'primereact/skeleton';
import { Toast } from 'primereact/toast';
import GeneralDialogFooter from '../shared/GeneralDialogFooter';
import FaDate from '../shared/FaDate';
import PresentAbsentSave from './PresentAbsentSave';
import ShowVideo from '../shared/ShowVideo';
import SchoolClassOperation from './SchoolClassOperation';
import TeacherNoteSave from './TeacherNoteSave';
import TeacherHistoryPresentAbsentView from './TeacherHistoryPresentAbsentView';


export default function TeacherHistoryPresentAbsent(props) {
  const [errorVisible, setErorVisible] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [deleting, setDeleting] = useState(false);
  const [loading, setLoading] = useState(false);
  const [confirmDeleteVisible, setConfirmDeleteVisible] = useState(false);
  const [schoolClass, setSchoolClass] = useState({});
  const [course, setCourse] = useState({});
  const [classes, setClasses] = useState([]);
  const [noteFormVisible, setNoteFormVisible] = useState(false);

  useEffect(() => {
    loadData();
  }, []);
  const loadData = function () {
    setLoading(true);
    var params = { login: util.getTrustedUser()};
    var url = config.Server + `/school/teacher/school-class/all/get`;
    console.log("params is>", params);
    console.log("url is>", url);
    axios
      .post(url, params)
      .then(res => {
        var response = res.data;
        if (response.state === "ok") {
          response = response.data;
          console.log(response);
          setClasses(response);
          setLoading(false);

        }
        else {
          setErrorMessage(response.message);
          setErorVisible(true);
          setLoading(false);
        }
      })
      .catch(error => {
        setErrorMessage(error.code + "," + error.message);
        setErorVisible(true);
        setLoading(false);
      });
  }
  const showNoteForm = function (cls, curs){
    setSchoolClass(cls);
    setCourse(curs);
    setNoteFormVisible(true);
  }
  const createNoteButton = function (schoolClass) {
    return (
      <div onClick={() => {showNoteForm(schoolClass.schoolClass, schoolClass.course)}} style={{position:"relative", display:"inline-block", textAlign:"center", float:"right", width:"32px", padding:"5px 0px 0px 0px", marginRight:"15px", border:"1px solid #b0b0b0", borderRadius:"5px", backgroundColor: "rgb(49, 113, 5)", color: "rgb(221, 240, 202)", cursor: "pointer"}}>
        <i class="bi bi-pencil-square"></i>
      </div>
    );
  }
  return (
    <>
      <ShowVideo videoId="teacher_notes" top={65} md={6} />
    <div>
      
      {
        loading ?
          <>loading...</>
          :
          <>
            <table border="1" style={{ borderCollapse: 'collapse', width: '100%', maxWidth: "400px", marginBottom:"200px" }}>
              <tbody>
                <tr>
                  <td style={{textAlign:'center'}}>برای مشاهده تاریخچه حضور و غیاب، کلاس را انتخاب نمائید</td>
                </tr>
                {
                  classes.map((cls, index)=>{
                    return(
                      <tr>
                        <td>
                            <div style={{ minWidth: "170px", backgroundColor: "#f7dbc5ff", height: "53px", position: "relative", margin: "5px", width: "calc(100% - 26px)", padding: "3px", borderRadius: "5px", border: "1px solid #b0b0b0" }}>
                              <table style={{width:"100%"}}>
                                <tbody>
                                  <tr>
                                    <td>{cls.schoolClass.name}</td>
                                    <td rowSpan={2} style={{width:"60px", borderRight:"1px dashed rgba(101, 150, 53, 1)"}}>
                                      {createNoteButton(cls)}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>
                                      {cls.course.name}
                                    </td>
                                  </tr>
                                </tbody>
                              </table>

                            </div>
                        </td>
                      </tr>
                    )
                  })
                }
              </tbody>
            </table>
          </>
      }
      {
        noteFormVisible ?
          <TeacherHistoryPresentAbsentView schoolClassId={schoolClass.id} courseId={course.id} onChange={() => {  }} onClose={() => setNoteFormVisible(false)} />
          :
          <></>
      }

      <ShowError visible={errorVisible} message={errorMessage} closeError={() => { setErorVisible(false) }} />
    </div>
    </>
  );
}
